﻿export * from './_blazor.js';
export * from './_form.js';
export * from './_page.js';
export * from './bootstrap/bootstrap.js';

window.blazorCulture = {
    get: () => window.localStorage['BlazorCulture'],
    set: (value) => window.localStorage['BlazorCulture'] = value
};